module.exports = __webpack_public_path__ + "media/images/footer-4c1094a38f3cd3d5ab2cf68721766681.jpg";